"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LanguagesSwitcher_1 = __importDefault(require("../LanguagesSwitcher"));
const Header_1 = __importDefault(require("../Header"));
const Content_1 = __importDefault(require("../Content"));
const styles_1 = require("./styles");
const user_json_1 = __importDefault(require("../../../dist/user.json"));
const Footer = () => ((0, jsx_runtime_1.jsxs)(styles_1.FooterWrapper, { children: ["CopyRight \u00A9 ", new Date().getFullYear(), " ", user_json_1.default.name, ". All rights reserved."] }));
const MainPage = () => ((0, jsx_runtime_1.jsxs)(styles_1.Paper, { children: [(0, jsx_runtime_1.jsx)(LanguagesSwitcher_1.default, {}), (0, jsx_runtime_1.jsx)(Header_1.default, {}), (0, jsx_runtime_1.jsx)(Content_1.default, {}), (0, jsx_runtime_1.jsx)(Footer, {})] }));
exports.default = MainPage;
